import { useAllMessages } from "./useAllMessages";
import { useMemo } from "react";
// hooks/useAggregatedLogs.js
import { useTopics } from "./useTopicsSimple";

export const useAggregatedLogs = (token) => {
  const {
    topics,
    loading: topicsLoading,
    error: topicsError,
  } = useTopics(token);
  const {
    allMessages,
    loading: messagesLoading,
    error: messagesError,
  } = useAllMessages(topics);

  const aggregatedLogs = useMemo(
    () =>
      [...allMessages].sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      ),
    [allMessages]
  );

  return {
    aggregatedLogs,
    loading: topicsLoading || messagesLoading,
    error: topicsError || messagesError,
  };
};
